import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { textBold } from 'theme/theme';
import { navigateToDocument } from '../../store/documents/actions';
import theme from '../../../theme';


const Document = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${theme.colors.medium};
  font-size: ${theme.fontSizes.medium};
  ${textBold};
  text-decoration: none;
  color: ${theme.colors.primary};
  &:hover {
    color: ${theme.colors.primaryDarker};
    cursor: pointer;
  }
`;

class DocumentLink extends React.Component {
  handleClick = () => {
    const { document, navigateToDocument } = this.props;
    return navigateToDocument(document);
  };

  render() {
    const { document } = this.props;
    return (
      <Document onClick={this.handleClick}> { /* eslint-disable-line */ }
        {document && document.name}
      </Document>
    );
  }
}
DocumentLink.propTypes = {
  document: PropTypes.objectOf(PropTypes.any).isRequired,
  navigateToDocument: PropTypes.func.isRequired,
};
DocumentLink.defaultProps = {
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
  navigateToDocument,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentLink);
